export default __webpack_public_path__ + "static/media/up.9f41b2ad.svg";